'use client';

import { signalHitlConfig } from '../../tools/signal/hitl-config';
import { EnhancedEditSignalModal } from '../modals/EnhancedEditSignalModal';
import type { SignalData } from '../types';

type SignalEditModalWrapperProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (editedArgs: Record<string, unknown>) => void;
  onApprove?: () => void;
  onReject?: (message?: string) => void;
  toolName?: string;
  extractedData?: unknown[];
};

export function SignalEditModalWrapper({
  isOpen,
  onClose,
  onSubmit,
  onApprove,
  onReject,
  toolName,
  extractedData = [],
}: SignalEditModalWrapperProps) {
  const hitlConfig = signalHitlConfig;

  const handleSubmit = (editedSignals: SignalData[]) => {
    if (!hitlConfig) return;
    const wrappedData = hitlConfig.wrapEditedData(editedSignals);
    onSubmit(wrappedData);
  };

  const handleApprove = () => {
    onApprove?.();
    onClose();
  };

  const handleReject = (message?: string) => {
    onReject?.(message);
    onClose();
  };

  if (!isOpen || extractedData.length === 0) return null;

  return (
    <EnhancedEditSignalModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      onApprove={onApprove ? handleApprove : undefined}
      onReject={onReject ? handleReject : undefined}
      signals={extractedData as SignalData[]}
      actionName={toolName}
    />
  );
}
